/**
 * Generated by orval v7.17.0 🍺
 * Do not edit manually.
 * TFA API
 * API for TFA
 * OpenAPI spec version: 2.0.0 (api.admin.v1)
 */

/**
 * * `YXS` - Youth XS
* `YS` - Youth S
* `YM` - Youth M
* `YL` - Youth L
* `YXL` - Youth XL
* `S` - Adult S
* `M` - Adult M
* `L` - Adult L
* `XL` - Adult XL
* `XXL` - Adult XXL
 */
export type JerseySizeEnum = typeof JerseySizeEnum[keyof typeof JerseySizeEnum];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const JerseySizeEnum = {
  YXS: 'YXS',
  YS: 'YS',
  YM: 'YM',
  YL: 'YL',
  YXL: 'YXL',
  S: 'S',
  M: 'M',
  L: 'L',
  XL: 'XL',
  XXL: 'XXL',
} as const;
